import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { UsuariosService } from '../_services';
import { first, map } from 'rxjs/operators';
import { CaptchaComponent } from 'angular-captcha';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {
  modalRef: BsModalRef;
  registroForm: FormGroup;
  submitted = false;
  loading = false;
  alerta = '';
  esRegistro: Boolean;
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;
  public user: any;
  public suscripciones: Array<object> = [];
  aceptado = false;

  constructor(
    private formBuilder: FormBuilder,
    private usuariosService: UsuariosService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService
  ) {
    this.esRegistro = !!route.snapshot.data['registro'];
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.registroForm.controls;
  }
  ngOnInit() {
    this.registroForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      celular: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      numero_documento: ['', [Validators.required]],
      captchaCode: [''],
      captchaId: [''],
      aceptado: ['']
    });
    if (!this.esRegistro) {
      this.registroForm.addControl(
        'notificar_sms',
        new FormControl('', Validators.nullValidator)
      );
      this.registroForm.addControl(
        'notificar_email',
        new FormControl('', Validators.nullValidator)
      );
      this.registroForm.addControl(
        'notificar_dispositivo',
        new FormControl('', Validators.nullValidator)
      );

      this.usuariosService.getCurrentUserInfo().subscribe((data: object) => {
        this.user = data;
        this.registroForm.controls.nombre.setValue(this.user.nombre);
        this.registroForm.controls.apellido.setValue(this.user.apellido);
        this.registroForm.controls.username.setValue(this.user.username);
        this.registroForm.controls.email.setValue(this.user.email);
        this.registroForm.controls.celular.setValue(this.user.celular);
        this.registroForm.controls.numero_documento.setValue(
          this.user.numero_documento
        );
        this.registroForm.controls.password.setValidators([
          Validators.nullValidator
        ]);
        this.registroForm.controls.password.updateValueAndValidity();
        this.registroForm.setValidators(this.passwordMatchValidator);
        this.registroForm.controls.notificar_sms.setValue(
          this.user.notificar_sms
        );
        this.registroForm.controls.notificar_email.setValue(
          this.user.notificar_email
        );
        this.registroForm.controls.notificar_dispositivo.setValue(
          this.user.notificar_dispositivo
        );
      });

      this.registroForm.addControl(
        'newPassword',
        new FormControl('', Validators.nullValidator)
      );
      this.registroForm.addControl(
        'confirmPassword',
        new FormControl('', Validators.nullValidator)
      );

      this.getSuscripciones();
    }
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registroForm.invalid) {
      return;
    }

    this.loading = true;
    this.alerta = '';
    if (this.esRegistro) {
      // cargo los campos del formulario en base al captchaComponent, para que se envíen con el formulario
      this.registroForm.controls.captchaCode.setValue(
        this.captchaComponent.captchaCode
      );
      this.registroForm.controls.captchaId.setValue(
        this.captchaComponent.captchaId
      );

      this.usuariosService
        .registrar(this.registroForm.value)
        .pipe(first())
        .subscribe(
          data => {
            console.log('Registration successful');
            this.loading = false;
            alert('¡Gracias por registrarte! Estamos procesando tus datos.');
            this.router.navigate(['/inicio']);
            // reload Captcha image
            this.captchaComponent.reloadImage();
          },
          error => {
            console.error(error);
            this.alerta = error;
            this.loading = false;
            // reload Captcha image
            this.captchaComponent.reloadImage();
          }
        );
    } else {
      this.usuariosService
        .editarUsuario(this.registroForm.value)
        .pipe(first())
        .subscribe(
          data => {
            console.log('Edit successful');
            this.loading = false;
            this.alerta = '';
            alert('Se han guardado correctamente los cambios realizados.');
            this.router.navigate(['/inicio']);
          },
          error => {
            console.error(error);
            this.alerta = error;
            this.loading = false;
          }
        );
    }
  }
  onClosed(dismissedAlert: any): void {
    this.alerta = '';
  }

  passwordMatchValidator(g: FormGroup) {
    if (g.get('newPassword').value === g.get('confirmPassword').value) {
      g.controls['newPassword'].setErrors(null);
      return null;
    } else {
      g.controls['newPassword'].setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }

  getSuscripciones() {
    this.usuariosService
      .getUsuarioSuscripciones()
      .subscribe((data: Array<object>) => {
        this.suscripciones = data;
      });
  }

  eliminarDispositivo(id: any) {
    if (!confirm('¿Desea eliminar la suscripción de este dispositivo?')) {
      return false;
    }
    this.usuariosService.deleteUsuarioSuscripcion(id).subscribe(data => {
      alert('Se elimino correctamente la suscripción');
      this.getSuscripciones();
    });
  }

  onAceptadoChange(event: any) {
    this.aceptado = !this.aceptado;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
}
